export const FLUND_FLM_PR_YEAR = 26071585;

export default {
  FLUND_FLM_PR_YEAR,
};
